var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleTickIcon = function SvgCircleTickIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.722 8.644a1.06 1.06 0 0 0 .034-1.448.943.943 0 0 0-1.379-.035L8.97 10.569 7.713 9.344a.943.943 0 0 0-1.378.054 1.06 1.06 0 0 0 .051 1.447l1.928 1.88a.943.943 0 0 0 1.372-.047l.036-.034z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.072 0C4.51 0 0 4.51 0 10.072c0 5.563 4.51 10.073 10.072 10.073 5.563 0 10.073-4.51 10.073-10.073C20.145 4.51 15.635 0 10.072 0M2 10.072a8.072 8.072 0 1 1 16.145 0 8.072 8.072 0 0 1-16.145 0",
    clipRule: "evenodd"
  })));
};
export default SvgCircleTickIcon;